import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LoaderState {
	isOpen: boolean;
	message?: string;
	loaderPosition?:
		"center" | "top" | "bottom" | "left" | "right" | "top-left" | "top-right" | "bottom-left" | "bottom-right";
	backdropColorClass?: string;
	backdropOpacityClass?: string;
	loaderColorClass?: string;
	textColorClass?: string;
	zIndex?: string;
	positioning?: "fixed" | "absolute";
	contentClassName?: string;
}

const initialState: LoaderState = {
	isOpen: false,
	message: "Loading...",
	loaderPosition: "center",
	backdropColorClass: "bg-black",
	backdropOpacityClass: "opacity-50",
	loaderColorClass: "border-blue-500",
	textColorClass: "text-white",
	zIndex: "z-70",
	positioning: "fixed",
	contentClassName: "bg-gray-900/85 p-5",
};

export const overlayLoaderSlice = createSlice({
	name: "overlayLoaderSlice",
	initialState,
	reducers: {
		showLoader: (state, action: PayloadAction<Partial<Omit<LoaderState, "isOpen">> | undefined>) => {
			state.isOpen = true;
			state.positioning = initialState.positioning;
			state.message = initialState.message;
			state.loaderPosition = initialState.loaderPosition;
			state.backdropColorClass = initialState.backdropColorClass;
			state.backdropOpacityClass = initialState.backdropOpacityClass;
			state.loaderColorClass = initialState.loaderColorClass;
			state.textColorClass = initialState.textColorClass;
			state.zIndex = initialState.zIndex;
			state.contentClassName = initialState.contentClassName;

			if (action.payload) {
				Object.assign(state, action.payload);
			}
		},
		hideLoader: state => {
			state.isOpen = false;
		},
		setLoaderOptions: (state, action: PayloadAction<Partial<LoaderState>>) => {
			Object.assign(state, action.payload);
		},
	},
});

export const { showLoader, hideLoader, setLoaderOptions } = overlayLoaderSlice.actions;
export default overlayLoaderSlice.reducer;
